export default __webpack_public_path__ + "static/pricingbg-fd8b3ae495d813921c5d8f773bd3a604.png";